import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import { createHashHistory } from 'history';

const hashHistory = createHashHistory();
export const routerStore = new RouterStore();

export const history = syncHistoryWithStore(hashHistory, routerStore);
